import React, {Component, Fragment, ComponentType, ReactNode} from 'react';
import {DropdownControlled} from '@homeaway/react-dropdown';
import {Button} from '@homeaway/react-buttons';
import MoreFiltersPanel, {
    Props as MoreFilterProps,
} from '../MoreFiltersPanel/MoreFiltersPanel';
import {FormattedMessage} from 'react-intl';
import {SVGIcon} from '@homeaway/react-svg';
import {FILTER__16} from '@homeaway/svg-defs';

import './MoreFiltersPanelDropdown.less';

type ProviderComponent = {
    searchResultsLoading: boolean;
};

type OwnProps = {
    toggleDropdown: () => void;
    open: boolean;
    searchResultsLoading: boolean;
    filterCountDataProvider: ComponentType<ProviderComponent>;
};

type StateProps = {
    numFiltersPanel?: number | null;
};

type Props = MoreFilterProps & OwnProps & StateProps;

const MORE_FILTERS_ID = 'moreFilters';

const filterCount = (num?: number | null): string => {
    return num && num > 0 ? `(${num})` : '';
};

export class MoreFiltersPanelDropdown extends Component<Props> {
    renderMoreFiltersPanel = ({filterGroups, resultsCount}) => {
        const {
            onApplyFilters,
            onInputParamsRangeFilterChange,
            onCancel,
            updatePriceInputValuesValidity,
            ...props
        } = this.props;
        return (
            <MoreFiltersPanel
                {...props}
                onApplyFilters={onApplyFilters}
                filterGroups={filterGroups}
                resultsCount={resultsCount}
                onInputParamsRangeFilterChange={onInputParamsRangeFilterChange}
                onCancel={onCancel}
                updatePriceInputValuesValidity={updatePriceInputValuesValidity}
            />
        );
    };

    renderButtonLabel = () => {
        return (
            <Fragment>
                <SVGIcon
                    markup={FILTER__16}
                    aria-hidden
                    className="FilterIcon"
                />
                <FormattedMessage
                    id={'moreFiltersLabel'}
                    defaultMessage={'More Filters'}
                >
                    {(txt: any): ReactNode =>
                        `${String(txt)} ${filterCount(
                            this.props.numFiltersPanel
                        )}`
                    }
                </FormattedMessage>
            </Fragment>
        );
    };

    render() {
        const {
            renderMoreFiltersPanel,
            props: {
                open,
                onApplyFilters,
                toggleDropdown,
                searchResultsLoading,
                filterCountDataProvider: FilteredCountDataProvider,
            },
        } = this;

        return (
            <DropdownControlled
                id={MORE_FILTERS_ID}
                label={this.renderButtonLabel()}
                customToggle={
                    <Button
                        id={MORE_FILTERS_ID}
                        label={this.renderButtonLabel()}
                    />
                }
                onDropdownClick={toggleDropdown}
                onBlur={onApplyFilters}
                onTouch={onApplyFilters}
                open={open}
                noArrow
                className="MoreFilters__btn"
            >
                {open && (
                    <FilteredCountDataProvider
                        children={renderMoreFiltersPanel}
                        searchResultsLoading={searchResultsLoading}
                    />
                )}
            </DropdownControlled>
        );
    }
}

export default MoreFiltersPanelDropdown;
